export function isCripto() {
    const email = sessionStorage.getItem('emailUser')?.toString();
    const criptoEmails = [
      'alandrietti@gmail.com',
      'nilo.mendonca@highersolucoes.com',
      'financeiro@highersolucoes.com',
      'financeiro@higherglobal.com.br',
      'davi@cryptouse.com.br',
      'bruno.riscado@highersolucoes.com',
      'nathan.diogo@cipay.com.br',
      'account.test@higherglobal.com.br',
    ];
  
    return criptoEmails.includes(email);
}